/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-fetching-library';
import qs from 'qs';

import { EditClip } from './EditClip';
import { ParticipantSelectionResponse } from 'api/actions/participantSelection/participantClipping.types';
import { participantSelection } from 'api/actions/participantSelection/participantClipping.actions';
import { timeToSec } from 'shared/utils/timeConversions/timeConversions';

export type EventIdParamType = { participantId: string };

export const EditClipContainer = () => {
  const params: any = qs.parse(window.location.href.split('?')[1]);

  const { payload } = useQuery<ParticipantSelectionResponse>(participantSelection(params.id));

  const firstName = payload && payload?.fullName?.split(' ');
  const isMatched = params.isMatched === 'true';
  const streamURL = payload && payload.streamUrl;
  const audioURL = payload && payload.audioUrl;
  const firsttName = payload && payload.firstName;
  const lastName = payload && payload.lastName;

  const { userId } = params;

  let audioStartTime: string | undefined;
  let audioEndTime: string | undefined;
  let videoStartTime: string | undefined;
  let videoEndTime: string | undefined;

  if (userId) {
    audioStartTime = payload && payload?.suggestions?.find(suggestion => suggestion.id === userId)?.start;
    audioEndTime = payload && payload.suggestions.find(suggestion => suggestion.id === userId)?.end;
    videoStartTime = payload && payload.suggestions.find(suggestion => suggestion.id === userId)?.walkingStartTime;
    videoEndTime = payload && payload.suggestions.find(suggestion => suggestion.id === userId)?.walkingEndTime;
  } else if (payload?.suggestions && payload?.suggestions?.length > 0) {
    audioStartTime = payload?.suggestions[0].start;
    audioEndTime = payload?.suggestions[0].end;
    videoStartTime = payload?.suggestions[0].walkingStartTime;
    videoEndTime = payload?.suggestions[0].walkingEndTime;
  } else {
    audioStartTime = payload?.audioStartTime;
    audioEndTime = payload?.audioEndTime;
    videoStartTime = payload?.videoStartTime;
    videoEndTime = payload?.videoEndTime;
  }

  const [audioStartSeconds, setAudioStartSeconds] = useState(0);
  const [audioEndSeconds, setAudioEndSeconds] = useState(0);
  const [videoStartSeconds, setVideoStartSeconds] = useState(0);
  const [videoEndSeconds, setVideoEndSeconds] = useState(0);

  useEffect(() => {
    if (audioStartTime && audioStartTime !== 'undefined') {
      setAudioStartSeconds(timeToSec(audioStartTime));
    }
  }, [audioStartTime]);

  useEffect(() => {
    if (audioEndTime && audioEndTime !== 'undefined') {
      setAudioEndSeconds(timeToSec(audioEndTime));
    }
  }, [audioEndTime]);

  useEffect(() => {
    if (videoStartTime && videoStartTime !== 'undefined') {
      setVideoStartSeconds(timeToSec(videoStartTime));
    }
  }, [videoStartTime]);

  useEffect(() => {
    if (videoEndTime && videoEndTime !== 'undefined') {
      setVideoEndSeconds(timeToSec(videoEndTime));
    }
  }, [videoEndTime]);

  return (
    <EditClip
      name={(firstName && firstName[0]) || ''}
      image={payload?.institutionLogo || ''}
      isMatched={isMatched}
      startTime={audioStartSeconds}
      audioEndTime={audioEndSeconds}
      streamURL={streamURL || ''}
      audioURL={audioURL || ''}
      userId={params.id}
      firstName={firsttName || ''}
      lastName={lastName || ''}
      renderLimit={payload?.renderLimit!}
      isFromSelfOnBoard={payload?.isFromSelfOnBoard}
      eventId={payload?.eventId}
      isLinkedInUser={payload?.isLinkedInUser}
      videoStartTime={videoStartSeconds}
      videoEndTime={videoEndSeconds}
    />
  );
};
